<template>
  <div>
    <AdminAppBar :route="''">{{ $route.params.type.charAt(0).toUpperCase() + $route.params.type.slice(1) }} Project
    </AdminAppBar>
    <div class="page-content header-clear-small">
      <div class="card card-style">
        <div class="input-style has-icon input-style-1 input-required">
          <span>Project Name</span>
          <em>(required)</em>
          <input v-model="project" placeholder="Project Name" type="text">
        </div>
        <div class="input-style has-icon input-style-1 input-required">
          <span>Project Details</span>
          <textarea v-model="details" placeholder="Project Details" rows="5"></textarea>
        </div>
        <div class="input-style has-icon input-style-1 input-required">
          <span>Contribution Amount</span>
          <em>(required)</em>
          <input v-model="amount" placeholder="Contribution Amount" type="number">
        </div>
        <div class="input-style has-icon input-style-1 input-required">
          <span>Start Date</span>
          <em>(required)</em>
          <input v-model="start_date" placeholder="Start Date" type="date">
        </div>
        <div v-if="$route.params.type === 'stand'" class="input-style has-icon input-style-1 input-required">
          <span>Number of Stands</span>
          <em>(required)</em>
          <input v-model="number_of_stands" placeholder="Number of Stands" type="number">
        </div>
        <div v-else class="input-style has-icon input-style-1 input-required">
          <span>Number of Participants</span>
          <em>(required)</em>
          <input v-model="number" placeholder="Number of Participants" type="number">
        </div>

        <div v-if="$route.params.type !== 'round'" class="input-style has-icon input-style-1 input-required">
          <span>Number of Contributions</span>
          <em>(optional)</em>
          <input v-model="number_of_contributions" placeholder="Number of Contributions" type="number">
        </div>
        <div v-if="$route.params.type !== 'round'" class="input-style has-icon input-style-1 input-required">
          <span>Contribution Interval</span>
          <em>(optional)</em>
          <select v-model="contribution_interval">
            <option value="month">Monthly Contributions</option>
          </select>
        </div>

        <p class="btn btn-m btn-full rounded-s shadow-l bg-green1-dark text-uppercase font-900" @click="saveProject">
          Save
          Account</p>
      </div>
    </div>
  </div>
</template>

<script>
import AdminAppBar from "@/components/admin/AdminAppBar";
import axios from "axios";
import global from "@/mixins/global";

export default {
  mixins: [global],
  name: "AdminCreateProject",
  components: {AdminAppBar},
  data() {
    return {
      project: "",
      details: "",
      start_date: "",
      amount: "",
      number: "",
      number_of_stands: "",
      number_of_contributions: "",
      contribution_interval: "month"
    }
  },
  methods: {
    saveProject() {
      axios.post(this.base_url+ this.$route.params.type + (this.$route.params.type === "farming" ? "" : "s"), {
        project: this.project,
        details: this.details,
        start_date: this.start_date,
        contribution_amount: this.amount,
        number: this.number,
        number_of_stands: this.number_of_stands,
        number_of_contributions: this.number_of_contributions,
        contribution_interval: this.contribution_interval
      }, this.requestAuthHeaderToken(localStorage.getItem("token")))
          .then(response => {
            if (Object.keys(response).length) {
              this.$router.back()
            }
          }).catch(error => {
        this.error = error
      })
    }
  }
}
</script>

<style scoped>
  textarea {
    /*padding-left: 30px;*/
    margin-left: 30px !important;
  }
  select{
    padding-left: 30px !important;
  }
</style>